import * as types from './types'
import storage from '@/plugins/storage'
export default () => ({
  brand: null,
  brands: [],
  bucketContents: [],
  pageSize: storage.session.getItem(types.BRANDS_PAGE_SIZE) || 10,
  retrospectiveDay: storage.session.getItem(types.BRANDS_DAYS) || 0,
  searchTerm: storage.session.getItem(types.BRANDS_SEARCH_TERM) || '',
  sortDir: storage.session.getItem(types.BRANDS_SORT_DIR) || 'desc',
  orderBy: storage.session.getItem(types.BRANDS_ORDER_BY) || 'Brand',
  filterBy: parseInt(storage.local.getItem(types.BRANDS_FILTER_BY)) || 9999,
  filterOptions: [],
  preferences: [],
  franchisees: [],
  shops: []
})



// WEBPACK FOOTER //
// ./src/store/modules/brands/state.js